var Backbone = require('backbone')
var Config = require('config')
var App = require('app')
var BaseModel = require('src/common/base-model')
var BaseCollection = require('src/common/base-collection')
var _ = require('lodash')

var Statistics = function () {
  var cached = {}

  // init
  var Statistics = BaseModel.extend({
    urlRoot: Config.api.host + '/statistics',
    idAttribute: '_id',
    // workaround to enable download from within javascript
    saveFile: function (name, type, data) {
      if (data != null && navigator.msSaveBlob) {
        return navigator.msSaveBlob(new Blob([data], { type: type }), name)
      }
      var url = window.URL.createObjectURL(new Blob([data], {type: type}))
      var hiddenLink = document.createElement('a')
      hiddenLink.style.display = 'none'
      hiddenLink.setAttribute('href', url)
      hiddenLink.setAttribute('download', name)
      document.body.appendChild(hiddenLink)
      // perform a click
      hiddenLink.click()
      //
      window.URL.revokeObjectURL(url)
      hiddenLink.remove()
    },
    download: function (options) {
      var self = this
      var defaultOptions = {'$format': 'csv'}
      options = _.extend(defaultOptions, options)

      jQuery.ajax({
        type: 'GET',
        beforeSend: function (request) {
          request.setRequestHeader('Content-Type', 'text/csv')
        },
        url: this.url(),
        data: options,
        success: function (msg) {
          self.saveFile(options.sensor + '_' + options.startDate + '_' + options.endDate + '_' + options.resolution + '.csv', 'data:text/csv', msg)
        }
      })
    }
  })

  // //
  var API = {
    getStatisticsEntity: function (options) {
      var statistics = new Statistics(options)
      return statistics
    }
  }

  // Listeners
  App.globalChannel.reply({
    'statistics:entity': API.getStatisticsEntity
  })

  // Init
  return API
//
}

module.exports = Statistics



// WEBPACK FOOTER //
// ./js/entities/statistics.js